module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Simplificado")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Simplificado',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('numeroProcesso')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "noticeNumber"
    }
  }, [_vm._v("Número do Processo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.processo.simplifiedNumber),
      expression: "processo.simplifiedNumber"
    }],
    staticClass: "form-control ng-pristine ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required ng-touched",
    staticStyle: {
      "background-image": "url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4EaVTO26DQBD1ohQWaS2lg9JybZ+AK7hNwx2oIoVf4UPQ0Lj1FdKktevIpel8AKNUkDcWMxpgSaIEaTVv3sx7uztiTdu2s/98DywOw3Dued4Who/M2aIx5lZV1aEsy0+qiwHELyi+Ytl0PQ69SxAxkWIA4RMRTdNsKE59juMcuZd6xIAFeZ6fGCdJ8kY4y7KAuTRNGd7jyEBXsdOPE3a0QGPsniOnnYMO67LgSQN9T41F2QGrQRRFCwyzoIF2qyBuKKbcOgPXdVeY9rMWgNsjf9ccYesJhk3f5dYT1HX9gR0LLQR30TnjkUEcx2uIuS4RnI+aj6sJR0AM8AaumPaM/rRehyWhXqbFAA9kh3/8/NvHxAYGAsZ/il8IalkCLBfNVAAAAABJRU5ErkJggg==\")",
      "background-repeat": "no-repeat",
      "background-attachment": "scroll",
      "background-size": "16px 18px",
      "background-position": "98% 50%"
    },
    attrs: {
      "name": "numeroProcesso",
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255",
      "required": ""
    },
    domProps: {
      "value": (_vm.processo.simplifiedNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.processo, "simplifiedNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('numeroProcesso')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroProcesso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.processo.active),
      expression: "processo.active"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "checked": "",
      "value": "true"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.processo.active, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.processo, "active", true)
      }
    }
  }), _vm._v(" Sim\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processo.active),
      expression: "processo.active"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "value": "false"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.processo.active, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.processo, "active", false)
      }
    }
  }), _vm._v(" Não\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('dataInicial')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "initialDate"
    }
  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.processo.initialDate),
      callback: function($$v) {
        _vm.$set(_vm.processo, "initialDate", $$v)
      },
      expression: "processo.initialDate"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('dataFinal')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "endDate"
    }
  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataFinal",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.processo.endDate),
      callback: function($$v) {
        _vm.$set(_vm.processo, "endDate", $$v)
      },
      expression: "processo.endDate"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('dataFinal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataFinal')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processo.id),
      expression: "processo.id"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "createdAt"
    }
  }, [_vm._v("Data criação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "createdAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.processo.createdAt, 'DD-MM-YYYY HH:MM')
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "updatedAt"
    }
  }, [_vm._v("Data atualização:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "updatedAt",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.processo.updatedAt, 'DD-MM-YYYY HH:MM')
    }
  })])]), _vm._v(" "), (_vm.processo.id) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processo.id && _vm.processo.inactivateDateTime),
      expression: "processo.id && processo.inactivateDateTime"
    }],
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "inactivateDateTime"
    }
  }, [_vm._v("Data inativação:")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processo.id && _vm.processo.inactivateDateTime),
      expression: "processo.id && processo.inactivateDateTime"
    }],
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "inactivateDateTime",
      "disabled": ""
    },
    domProps: {
      "value": _vm._f("moment")(_vm.processo.inactivateDateTime, 'DD-MM-YYYY HH:MM')
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2 ng-scope",
    attrs: {
      "for": "changedBy"
    }
  }, [_vm._v("Alterado por:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 ng-scope"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "changedBy",
      "disabled": ""
    },
    domProps: {
      "value": _vm.processo.changedBy
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salva
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de Simplificado")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09700554!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/simplificado/EditarSimplificado.vue
// module id = 1855
// module chunks = 1